import { CreditCardIcon } from "./Icons";
import { CreditCardIssuer } from "./issuers";


interface CreditCardIssuerStyle {
  background: string;
  logotype: string;
}

export const CreditCardIssuerStyles: Record<CreditCardIssuer, CreditCardIssuerStyle> = {
  amex: {
    background: "linear-gradient(25deg, #308c67, #a3f2cf)",
    logotype: CreditCardIcon.amex,
  },
  discover: {
    background: "linear-gradient(25deg, #fff, #eee)",
    logotype: CreditCardIcon.discover,
  },
  mastercard: {
    background: "linear-gradient(25deg, #333333, #4a4a4a);",
    logotype: CreditCardIcon.mastercard,
  },
  visa: {
    background: "linear-gradient(25deg, #0f509e, #1399cd)",
    logotype: CreditCardIcon.visa,
  },
  unionpay: {
    background: "linear-gradient(25deg, #999, #999)",
    logotype: CreditCardIcon.unionpay,
  },
  diners: {
    background: "linear-gradient(25deg, #fff, #eee)",
    logotype: CreditCardIcon.diners,
  },
  jcb: {
    background: "linear-gradient(25deg, #999, #999)",
    logotype: CreditCardIcon.jcb,
  },
  unknown: {
    background: "linear-gradient(25deg, #999, #999)",
    logotype: CreditCardIcon.unknown,
  }
}


